module.exports = __webpack_public_path__ + "img/klarna.e42bbd99.svg";